export default __webpack_public_path__ + "static/media/clap-icon.677a5ef7.svg";